var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-companion-overlay-wrapper",
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-companion-overlay",
          class: [
            _vm.showCompanion ? "cw-companion-overlay-in" : "",
            _vm.showCompanion ? "" : "cw-companion-overlay-out",
            _vm.styleCompanion,
          ],
          attrs: {
            "aria-hidden": "true",
          },
        },
        [
          _c("div", {
            staticClass: "cw-companion-overlay-content",
            domProps: {
              innerHTML: _vm._s(_vm.msgCompanion),
            },
          }),
          _vm._v(" "),
          _c("button", {
            staticClass: "cw-compantion-overlay-close",
            on: {
              click: _vm.hideCompanion,
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sr-only",
          attrs: {
            "aria-live": "polite",
            role: "log",
          },
        },
        [_c("p", [_vm._v(_vm._s(_vm.msgCompanion))])]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }